import BlendButton from "./blend-button";

export default BlendButton;
